export default __webpack_public_path__ + "static/media/img_services05.da74dbe8.png";